class MediatecaLoadMore {
  constructor() {
    this.itemsPerLoad = 18;
    this.currentIndex = 0;
    
    // Aguardar um pouco para garantir que o DOM está pronto
    setTimeout(() => {
      this.mediatecaData = this.loadData();
      this.loadMoreBtn = document.getElementById('load-more-btn');
      this.gridContainer = document.getElementById('mediateca-grid-container');
      this.filteredData = [...this.mediatecaData];
      this.activeFilters = { categories: [], sortOrder: '', year: '' };

      this.init();
    }, 100);
  }

  loadData() {
    const dataScript = document.getElementById('mediateca-data');
    
    if (dataScript) {
      const scriptContent = dataScript.textContent.trim();
      
      try {
        const data = JSON.parse(scriptContent);
        
        if (data.entries && data.entries.length > 0) {
        }
        
        const sortedEntries = (data.entries || []).sort(
          (a, b) => (b.timestamp || 0) - (a.timestamp || 0)
        );
        
        
        sortedEntries.slice(0, 3).forEach(entry => {
          console.log('-', entry.data_mediateca, ':', entry.titulo);
        });
        
        return sortedEntries;
      } catch (e) {
        console.error('Erro ao parsear dados de mediateca:', e);
        console.error('Mensagem:', e.message);
        console.error('Conteúdo do script (primeiros 500):', scriptContent.substring(0, 500));
        return [];
      }
    }
    
    console.error('Script #mediateca-data não encontrado no DOM');
    return [];
  }

  init() {
    
    if (!this.loadMoreBtn || !this.gridContainer) {
      console.error('loadMoreBtn ou gridContainer não encontrados');
      return;
    }

    if (this.mediatecaData.length === 0) {
      console.warn('Nenhum dado de mediateca disponível');
      this.loadMoreBtn.style.display = 'none';
      this.gridContainer.innerHTML = '<p class="text-center">Nenhum item disponível.</p>';
      return;
    }


    // Carregar os primeiros itens
    this.loadMoreItems();

    this.loadMoreBtn.addEventListener('click', () => {
      this.loadMoreItems();
    });

    // Escutar mudanças de filtro
    document.addEventListener('mediateca-filter-change', (e) => {
      this.applyFilters(e.detail);
    });
  }

  loadMoreItems() {
    
    const endIndex = Math.min(this.currentIndex + this.itemsPerLoad, this.filteredData.length);
    
    for (let i = this.currentIndex; i < endIndex; i++) {
      const entry = this.filteredData[i];
      this.addMediaToGrid(entry);
    }

    this.currentIndex = endIndex;

    // Esconder botão se chegou ao fim
    if (this.currentIndex >= this.filteredData.length) {
      this.loadMoreBtn.style.display = 'none';
    } else {
      this.loadMoreBtn.style.display = 'inline-block';
    }

    // Disparar evento para atualizar filtros se houver
    document.dispatchEvent(new CustomEvent('mediateca-entries-loaded'));
  }

  addMediaToGrid(media) {
    
    // Criar ou obter a seção do ano
    let yearSection = this.gridContainer.querySelector(`[data-year="${media.ano}"]`);
    
    if (!yearSection) {
      yearSection = document.createElement('div');
      yearSection.className = 'mediateca-year-section';
      yearSection.setAttribute('data-year', media.ano);
      
      const title = document.createElement('h2');
      title.className = 'h4 mediateca-year-title';
      title.textContent = media.ano;
      
      const gridRow = document.createElement('div');
      gridRow.className = 'row mediateca-year-grid';
      gridRow.setAttribute('data-year-grid', media.ano);
      
      yearSection.appendChild(title);
      yearSection.appendChild(gridRow);
      
      // Inserir seção na ordem correta (mais recente primeiro)
      const existingSections = Array.from(this.gridContainer.querySelectorAll('.mediateca-year-section'));
      let inserted = false;
      
      for (let section of existingSections) {
        const sectionYear = parseInt(section.getAttribute('data-year'));
        if (parseInt(media.ano) > sectionYear) {
          this.gridContainer.insertBefore(yearSection, section);
          inserted = true;
          break;
        }
      }
      
      if (!inserted) {
        this.gridContainer.appendChild(yearSection);
      }
      
    }

    // Criar elemento da media
    const mediaDiv = document.createElement('div');
    mediaDiv.className = 'col-lg-6 col-12 mediateca-entry';
    mediaDiv.setAttribute('data-year', media.ano);
    mediaDiv.setAttribute('data-titulo', media.data_titulo || media.titulo.toLowerCase());
    mediaDiv.setAttribute('data-categoria', media.data_categoria || '');

    // Verificar se categoria é array
    const categoriaArray = Array.isArray(media.categoria) ? media.categoria : [];
    const artistasArray = Array.isArray(media.artistas_relacionados) ? media.artistas_relacionados : [];

    mediaDiv.innerHTML = `
      <div class="related-media-item position-relative mb-5">
        <div class="image-media position-relative">
          ${media.imagem_listagem ? `
            <a class="" href="${media.url_page || '#'}">
              <img class="imageShare-page" src="${media.imagem_listagem}" alt="${media.titulo || ''}">
            </a>
          ` : ''}
        </div>

        <div class="info-media">
          ${categoriaArray.length > 0 ? `
            <div class="tags tags-dark mb-3">
              ${categoriaArray.map(tag => `<span>${tag}</span>`).join('')}
            </div>
          ` : ''}
          <div class="title-media mb-2">
            <a class="stretched-link no-decoration-black h4" href="${media.url_page || '#'}">
              ${media.titulo || ''}
            </a>
          </div>
          <div class="artist-name text-uppercase paragraph-sm">
            ${(() => {
              const artistas = artistasArray.length > 0
                ? artistasArray.map(artista => artista.titulo || artista || '')
                : media.nome_do_artista
                  ? [media.nome_do_artista.titulo || media.nome_do_artista]
                  : [];

              const nomesFormatados = artistas
                .map(nome => String(nome).trim())
                .filter(Boolean)
                .join(', ')
                .replace(/\s*,\s*/g, ', ')
                .replace(/\s+/g, ' ')
                .trim();

              return `<span>${nomesFormatados}</span>`;
            })()}
          </div>
          <div class="paragraph-sm mt-3">
            ${media.ano || ''}
          </div>
        </div>
      </div>
    `;

    const yearGrid = yearSection.querySelector('[data-year-grid]');
    if (yearGrid) {
      yearGrid.appendChild(mediaDiv);
    } else {
      console.error('yearGrid não encontrado para ano', media.ano);
    }
  }

  applyFilters(filterData) {
    
    this.activeFilters = { ...this.activeFilters, ...filterData };
    
    // Filtrar dados baseado nos filtros ativos
    this.filteredData = this.mediatecaData.filter((entry) => {
      // Filtro por categoria
      if (this.activeFilters.categories.length > 0) {
        const entryCategories = (entry.categoria || []).map(cat => 
          cat.toLowerCase().replace(/ /g, '-')
        );
        const hasCategory = this.activeFilters.categories.some(cat =>
          entryCategories.includes(cat.toLowerCase())
        );
        if (!hasCategory) return false;
      }

      // Filtro por ano
      if (this.activeFilters.year) {
        if (entry.ano !== this.activeFilters.year) return false;
      }

      return true;
    });

        // Ordenação
    if (this.activeFilters.sortOrder === 'asc') {
      this.filteredData.sort((a, b) => a.titulo.localeCompare(b.titulo));
    } else if (this.activeFilters.sortOrder === 'desc') {
      this.filteredData.sort((a, b) => b.titulo.localeCompare(a.titulo));
    } else {
      this.filteredData.sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
    }

    // Resetar índice e recarregar grid
    this.currentIndex = 0;
    this.gridContainer.innerHTML = '';
    this.loadMoreItems();
  }
}

// Inicializar quando o DOM estiver pronto
function initMediatecaLoadMore() {
  new MediatecaLoadMore();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMediatecaLoadMore);
} else {
  // DOM já está pronto, inicializar imediatamente
  initMediatecaLoadMore();
}
